import Lista from './Lista';

export const UniformeLista = Lista;
